import * as React from 'react';
import { ChevronDown } from 'lucide-react';

import { cn } from '@/lib/utils';

/**
 * Native HTML select styled to match the Unify design tokens. Sufficient for
 * the simple "select a value" cases on Settings and filter bars; reach for a
 * Radix select if we need typeahead / multi-select / custom item rendering.
 */
const Select = React.forwardRef(({ className, children, ...props }, ref) => (
	<div className={cn('relative inline-flex w-full', className)}>
		<select
			ref={ref}
			className={cn(
				'h-10 w-full appearance-none rounded-md border border-input bg-background px-3 pr-9 text-sm',
				'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
				'disabled:cursor-not-allowed disabled:opacity-50'
			)}
			{...props}
		>
			{children}
		</select>
		<ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
	</div>
));
Select.displayName = 'Select';

export { Select };
